import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06112896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data" }
const _hoisted_2 = { class: "side-menu" }

export function render(_ctx, _cache) {
  const _component_SideMenu = _resolveComponent("SideMenu")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SideMenu, {
        menuItems: _ctx.menuItems,
        "onUpdate:menuItems": _cache[0] || (_cache[0] = $event => ((_ctx.menuItems) = $event)),
        onMenuSelected: _ctx.menuAction,
        onMenuClosed: _ctx.menuClosed
      }, null, 8, ["menuItems", "onMenuSelected", "onMenuClosed"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["page-container", _ctx.menuWidth < 100? 'menuClosed' : ''])
    }, [
      _createVNode(_component_router_view)
    ], 2)
  ]))
}